/* hs-eslint ignored failing-rules */
/* eslint-disable no-bitwise */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["email", "hubSpotUserEmail"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import envSuffix from './lib/envSuffix';
import MD5 from './lib/MD5';
import { AVATAR_SIZES, RETINA_MULTIPLIER } from './Constants';
import UIAvatarDisplay from './UIAvatarDisplay/UIAvatarDisplay';
import devLogger from 'react-utils/devLogger';
import defaultContactImage from 'bender-url!ui-addon-avatars/images/default-avatar.png';
import { jsx as _jsx } from "react/jsx-runtime";
class UIUnauthedHubSpotUserAvatar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldRender: false
    };
  }
  componentDidMount() {
    const imageURI = this.getHubSettingsUrl();
    const that = this;
    if (this.props._noDefaultSrc) {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', imageURI);
      xhr.onerror = () => {
        return this.setState({
          shouldRender: false
        });
      };
      xhr.onload = () => {
        const img = new Image();
        const response = xhr.responseText;
        let binary = '';
        for (let i = 0; i < response.length; i++) {
          binary += String.fromCharCode(response.charCodeAt(i) & 0xff);
        }
        img.src = `data:image/jpeg;base64${btoa(binary)}`;
        return that.setState({
          shouldRender: img.src
        });
      };
      xhr.overrideMimeType('text/plain; charset=x-user-defined');
      xhr.send();
    }
    return this.setState({
      shouldRender: imageURI
    });
  }
  getEmailHash() {
    const {
      email,
      hubSpotUserEmail
    } = this.props;
    return MD5((hubSpotUserEmail || email).toLowerCase());
  }
  getHubSettingsUrl() {
    const {
      hubSpotUserEmail,
      size
    } = this.props;
    const email = hubSpotUserEmail || this.props.email;
    if (typeof email === 'undefined') {
      return defaultContactImage;
    }
    const sizePx = size !== AVATAR_SIZES.responsive ? AVATAR_SIZES[size] : AVATAR_SIZES.xl;
    const doubleDimensionForRetina = sizePx * RETINA_MULTIPLIER;
    return `https://app.hubspot${envSuffix()}.com/hubsettings/v1/avatar/hash/${this.getEmailHash()}/${doubleDimensionForRetina}`;
  }
  render() {
    const _this$props = this.props,
      {
        email,
        hubSpotUserEmail
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return this.state.shouldRender && /*#__PURE__*/_jsx(UIAvatarDisplay, Object.assign({}, rest, {
      hubSpotUserEmail: hubSpotUserEmail || email,
      src: this.state.shouldRender,
      displayName: hubSpotUserEmail || email
    }));
  }
}
UIUnauthedHubSpotUserAvatar.defaultProps = {
  size: 'sm'
};
const deprecatedInFavorOf = newPropToUse => (props, propName, componentName) => {
  if (props[propName] && !props[newPropToUse]) {
    devLogger.warn({
      message: `Use ${newPropToUse} instead of ${propName} in ${componentName}`
    });
  }
  return null;
};
UIUnauthedHubSpotUserAvatar.propTypes = {
  _noDefaultSrc: PropTypes.bool,
  email: deprecatedInFavorOf('hubSpotUserEmail'),
  hubSpotUserEmail: PropTypes.string.isRequired,
  size: UIAvatarDisplay.propTypes.size
};
export default UIUnauthedHubSpotUserAvatar;